(function(){
  function pad(n){return (n<10?'0':'')+n}
  function each(list,fn){Array.prototype.forEach.call(list,fn)}
  function getCode(){
    var k='kilde_res_id',c=null;
    try{c=localStorage.getItem(k)}catch(e){}
    if(!c){var a='ABCDEFGHJKMNPQRSTUVWXYZ23456789';c='KLD-';for(var i=0;i<5;i++){c+=a.charAt(Math.floor(Math.random()*a.length))}try{localStorage.setItem(k,c)}catch(e){}}
    return c;
  }
  function tzLabel(){
    try{var p=new Intl.DateTimeFormat('en-US',{timeZoneName:'short'}).formatToParts(new Date());for(var i=0;i<p.length;i++){if(p[i].type==='timeZoneName')return ' '+p[i].value}}catch(e){}
    return '';
  }
  /* Countdown runs to the end of the week (Saturday 11:59:59 PM, visitor's local time), not midnight. */
  function weekEnd(n){var e=new Date(n.getTime());e.setDate(e.getDate()+(6-e.getDay()));e.setHours(23,59,59,999);return e}
  function tick(){
    var n=new Date(),e=weekEnd(n);
    var s=Math.max(0,Math.floor((e-n)/1000)),d=Math.floor(s/86400);s=s%86400;
    var t=(d>0?d+'d ':'')+pad(Math.floor(s/3600))+':'+pad(Math.floor(s%3600/60))+':'+pad(s%60);
    each(document.querySelectorAll('[data-k-clock]'),function(el){el.textContent=t});
  }
  function weekLabels(){
    each(document.querySelectorAll('.k-oto__timer'),function(el){var c=el.querySelector('[data-k-clock]');if(!c)return;el.textContent='Ends this week ';el.appendChild(c)});
  }

  /* ===== Kilde sale calendar =====
     window.KSALE (header setting) = 'auto' or a fixed sale name.
     Any element with data-k-sale="...%sale%..." gets %sale% replaced.
     Console: KILDE.sale  /  KILDE.calendar(2026) */
  function nthDow(y,m,dow,n){var d=new Date(y,m,1);var off=(dow-d.getDay()+7)%7;return new Date(y,m,1+off+(n-1)*7)}
  function lastDow(y,m,dow){var d=new Date(y,m+1,0);var off=(d.getDay()-dow+7)%7;return new Date(y,m,d.getDate()-off)}
  function addD(d,n){return new Date(d.getFullYear(),d.getMonth(),d.getDate()+n)}
  function calendar(y){
    var tg=nthDow(y,10,4,4),cm=addD(tg,4),mem=lastDow(y,4,1),lab=nthDow(y,8,1,1),D=function(m,d){return new Date(y,m,d)};
    return [
      ['New Year',D(0,1),D(0,10)],['Winter',D(0,11),D(1,1)],['Valentine\'s',D(1,2),D(1,14)],['Winter',D(1,15),D(2,19)],
      ['Spring',D(2,20),addD(mem,-8)],['Memorial Day',addD(mem,-7),mem],['Summer',addD(mem,1),D(5,24)],['4th of July',D(5,25),D(6,5)],
      ['Summer',D(6,6),addD(lab,-8)],['Labor Day',addD(lab,-7),lab],['Fall',addD(lab,1),D(8,30)],['Halloween',D(9,1),D(9,31)],
      ['Early Black Friday',D(10,1),addD(tg,-1)],['Black Friday',tg,addD(tg,3)],['Cyber Monday',cm,addD(cm,1)],
      ['Holiday',addD(cm,2),D(11,17)],['Last-Minute Gift',D(11,18),D(11,24)],['New Year',D(11,25),D(11,31)]
    ];
  }
  function saleName(now){
    var fixed=window.KSALE;if(fixed&&fixed!=='auto')return fixed;
    now=now||new Date();var t=new Date(now.getFullYear(),now.getMonth(),now.getDate()).getTime(),c=calendar(now.getFullYear());
    for(var i=0;i<c.length;i++){if(t>=c[i][1].getTime()&&t<=c[i][2].getTime())return c[i][0]}
    return 'Limited-time';
  }
  function applySale(){
    var n=saleName();
    var kn;try{kn=parseInt(localStorage.getItem('kilde_kits'),10)}catch(e){}
    if(!(kn>=4&&kn<=10)){kn=4+Math.floor(Math.random()*7);try{localStorage.setItem('kilde_kits',String(kn))}catch(e){}}
    each(document.querySelectorAll('[data-k-sale]'),function(el){el.textContent=el.getAttribute('data-k-sale').replace(/%sale%/g,n).replace(/\[N\]/g,kn+'/1,000')});
    each(document.querySelectorAll('.k-oto__bar i'),function(el){el.style.width=Math.max(2,kn*0.5)+'%'});
    window.KILDE={sale:n,calendar:function(y){return calendar(y||new Date().getFullYear()).map(function(r){return r[0]+': '+r[1].toDateString()+' to '+r[2].toDateString()})}};
  }
  function initPdp(root){
    var idInput=root.querySelector('[data-k-id]');
    var radios=Array.prototype.slice.call(root.querySelectorAll('input[name=k-tier]'));
    var up=root.querySelector('[data-k-upgrade]');
    var gifts=Array.prototype.slice.call(root.querySelectorAll('[data-k-gift]'));
    function bundleRadio(){for(var i=0;i<radios.length;i++){if(radios[i].getAttribute('data-level')==='1')return radios[i]}return null}
    function selected(){for(var i=0;i<radios.length;i++){if(radios[i].checked)return radios[i]}return radios[0]}
    function render(fromUser){
      var r=selected();if(!r)return;
      var level=parseInt(r.getAttribute('data-level')||'0',10),src=r;
      if(up&&level===1&&up.checked){level=2;src=up}
      if(up&&level===0){up.checked=false}
      if(idInput)idInput.value=src.value;
      each(document.querySelectorAll('[data-k-atc-price]'),function(el){el.textContent=src.getAttribute('data-price')});
      each(root.querySelectorAll('[data-k-atc-save]'),function(el){el.textContent=src.getAttribute('data-save')||src.getAttribute('data-price')});
      var cta=src.getAttribute('data-cta');
      if(cta){each(root.querySelectorAll('[data-k-atc-label]'),function(el){el.textContent=cta})}
      var isUp=!!(up&&src===up);
      each(root.querySelectorAll('.k-tier'),function(t){var on=t.contains(r);t.classList.toggle('is-on',on);t.classList.toggle('is-up',on&&isUp)});
      each(root.querySelectorAll('.k-up'),function(u){u.classList.toggle('is-on',isUp)});
      var total=0;
      gifts.forEach(function(g){
        var u=parseInt(g.getAttribute('data-unlock')||'0',10),locked=level<u,was=g.classList.contains('is-locked');
        g.classList.toggle('is-locked',locked);
        if(!locked){total+=parseFloat(g.getAttribute('data-value')||'0')}
        if(fromUser&&was&&!locked){g.classList.remove('k-pop');void g.offsetWidth;g.classList.add('k-pop')}
      });
      each(root.querySelectorAll('[data-k-gift-total]'),function(el){el.textContent='$'+Math.round(total)});
      each(root.querySelectorAll('[data-k-gift-item]'),function(el){el.disabled=level<parseInt(el.getAttribute('data-unlock')||'0',10)});
    }
    each(root.querySelectorAll('form.k-form'),function(f){f.addEventListener('submit',function(e){
      var extra=[];each(f.querySelectorAll('[data-k-gift-item]'),function(el){if(!el.disabled&&el.value)extra.push({id:parseInt(el.value,10),quantity:1})});
      if(!extra.length||!window.fetch||f.getAttribute('data-k-busy'))return;
      e.preventDefault();f.setAttribute('data-k-busy','1');
      var id=f.querySelector('[data-k-id]'),code=f.querySelector('[data-k-code-input]'),ret=f.querySelector('[name=return_to]');
      var main={id:parseInt(id.value,10),quantity:1};if(code&&code.value){main.properties={'_Reservation ID':code.value}}
      var root_=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
      fetch(root_+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[main].concat(extra)})})
        .then(function(r){if(!r.ok)throw r;window.location.href=ret?ret.value:root_+'cart'})
        .catch(function(){f.submit()});
    })});
    radios.forEach(function(r){r.addEventListener('change',function(){render(true)})});
    if(up){up.addEventListener('change',function(){if(up.checked){var b=bundleRadio();if(b)b.checked=true}render(true)})}
    gifts.forEach(function(g){g.addEventListener('click',function(){
      if(!g.classList.contains('is-locked'))return;
      var u=parseInt(g.getAttribute('data-unlock')||'0',10),b=null,bl=99;
      radios.forEach(function(x){var l=parseInt(x.getAttribute('data-level')||'0',10);if(l>=u&&l<bl){b=x;bl=l}});
      if(!b)b=bundleRadio();
      if(b)b.checked=true;
      if(u>=2&&up&&bl<u)up.checked=true;
      render(true);
    })});
    var main=root.querySelector('.k-main-img'),gm=root.querySelector('.k-gallery__main'),cur=0;
    var thumbs=Array.prototype.slice.call(root.querySelectorAll('[data-k-thumb]'));
    var trk=root.querySelector('[data-k-thumbs]'),tp=root.querySelector('[data-k-thumbs-prev]'),tn=root.querySelector('[data-k-thumbs-next]');
    function navState(){if(tp)tp.disabled=cur<=0;if(tn)tn.disabled=cur>=thumbs.length-1}
    thumbs.forEach(function(b,i){
      b.addEventListener('click',function(){
        cur=i;
        if(main){main.removeAttribute('srcset');main.src=b.getAttribute('data-src')}
        if(gm){gm.classList.toggle('is-alt',i>0);var tg=gm.querySelector('.k-gallery__tag');if(tg)tg.style.display=i>0?'none':'';}
        thumbs.forEach(function(x){x.classList.toggle('is-on',x===b)});
        if(trk){trk.scrollTo({left:Math.max(0,b.offsetLeft-(trk.clientWidth-b.offsetWidth)/2),behavior:'smooth'})}
        navState();
      });
    });
    if(tp)tp.addEventListener('click',function(){if(cur>0)thumbs[cur-1].click()});
    if(tn)tn.addEventListener('click',function(){if(cur<thumbs.length-1)thumbs[cur+1].click()});
    if(gm&&thumbs.length>1){var sx=0,sy=0,tracking=false;
      gm.addEventListener('touchstart',function(e){var t=e.touches[0];sx=t.clientX;sy=t.clientY;tracking=true},{passive:true});
      gm.addEventListener('touchend',function(e){if(!tracking)return;tracking=false;var t=e.changedTouches[0],dx=t.clientX-sx,dy=t.clientY-sy;
        if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy)*1.2){if(dx<0&&cur<thumbs.length-1)thumbs[cur+1].click();else if(dx>0&&cur>0)thumbs[cur-1].click()}},{passive:true});
      gm.style.touchAction='pan-y';}
    navState();
    render(false);
  }
  function initRails(){
    each(document.querySelectorAll('.k-mugc'),function(w){
      var rail=w.querySelector('[data-k-ugc-rail]');if(!rail)return;
      function step(d){var c=rail.querySelector('.k-mugc__card');var wd=c?c.getBoundingClientRect().width+10:200;rail.scrollBy({left:d*wd,behavior:'smooth'})}
      var p=w.querySelector('[data-k-ugc-prev]'),n=w.querySelector('[data-k-ugc-next]');
      if(p)p.addEventListener('click',function(){step(-1)});
      if(n)n.addEventListener('click',function(){step(1)});
    });
    var vids=document.querySelectorAll('.k-mugc video,.k-tst video');
    if(vids.length&&'IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){var v=e.target;if(e.isIntersecting){v.muted=true;var pr=v.play();if(pr&&pr.catch)pr.catch(function(){})}else{v.pause()}})},{threshold:.35});
      each(vids,function(v){v.muted=true;v.setAttribute('playsinline','');v.setAttribute('loop','');io.observe(v)});
    }
  }
  function initTst(){
    each(document.querySelectorAll('[data-k-tst]'),function(s){
      var tr=s.querySelector('[data-k-tst-track]');if(!tr||!tr.children.length)return;
      var cards=tr.children,dots=s.querySelector('[data-k-tst-dots]'),i=0,timer=null,paused=false,st=null;
      function gap(){return parseFloat(getComputedStyle(tr).columnGap)||16}
      function cw(){return cards[0].getBoundingClientRect().width+gap()}
      function per(){return Math.max(1,Math.round((tr.clientWidth+gap())/cw()))}
      function pages(){return Math.max(1,cards.length-per()+1)}
      function renderDots(){
        if(!dots)return;var n=pages();
        if(dots.children.length!==n){dots.innerHTML='';for(var d=0;d<n;d++){(function(d){var b=document.createElement('button');b.type='button';b.setAttribute('aria-label','Show review '+(d+1));b.addEventListener('click',function(){go(d);restart()});dots.appendChild(b)})(d)}}
        each(dots.children,function(b,k){b.classList.toggle('is-on',k===i)});
      }
      function go(k){var n=pages();i=((k%n)+n)%n;tr.scrollTo({left:i*cw(),behavior:'smooth'});renderDots()}
      function restart(){clearInterval(timer);timer=setInterval(function(){if(!paused&&!document.hidden)go(i+1)},5500)}
      var p=s.querySelector('[data-k-tst-prev]'),n=s.querySelector('[data-k-tst-next]');
      if(p)p.addEventListener('click',function(){go(i-1);restart()});
      if(n)n.addEventListener('click',function(){go(i+1);restart()});
      s.addEventListener('mouseenter',function(){paused=true});s.addEventListener('mouseleave',function(){paused=false});
      tr.addEventListener('touchstart',function(){paused=true},{passive:true});
      tr.addEventListener('scroll',function(){clearTimeout(st);st=setTimeout(function(){var k=Math.round(tr.scrollLeft/cw());if(k!==i){i=Math.min(k,pages()-1);renderDots()}},120)},{passive:true});
      window.addEventListener('resize',function(){renderDots()});
      renderDots();restart();
    });
  }
  function initReveal(){
    var els=document.querySelectorAll('[data-k-reveal]:not(.is-in)');if(!els.length)return;
    if(!('IntersectionObserver' in window)){each(els,function(el){el.classList.add('is-in')});return}
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}})},{rootMargin:'0px 0px -8% 0px',threshold:0.05});
    each(els,function(el){io.observe(el)});
  }
  document.addEventListener('shopify:section:load',function(){initReveal()});
  function init(){
    applySale();
    initReveal();
    var code=getCode(),tz=tzLabel();
    each(document.querySelectorAll('[data-k-code]'),function(el){el.textContent=code});
    each(document.querySelectorAll('[data-k-code-input]'),function(el){el.value=code});
    each(document.querySelectorAll('[data-k-end]'),function(el){el.textContent='Saturday 11:59 PM'+tz});
    weekLabels();
    if(document.querySelector('[data-k-clock]')){tick();setInterval(tick,1000)}
    each(document.querySelectorAll('[data-k-pdp]'),initPdp);
    initRails();initTst();
    var sticky=document.querySelector('[data-k-sticky]'),atc=document.querySelector('.k-atc');
    if(sticky&&atc&&'IntersectionObserver' in window){
      new IntersectionObserver(function(es){var e=es[0];sticky.classList.toggle('is-on',!e.isIntersecting&&e.boundingClientRect.top<0)}).observe(atc);
    }
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init)}else{init()}
})();
